import styled, { css } from 'styled-components'

import { mainColors, rgba, semanticColors } from '@avantstay/backoffice-core'

export const NotificationButton = styled.button<{ hasNotifications: boolean }>`
  position: relative;
  margin-left: 8px;
  display: flex;
  padding: 9px;
  gap: 10px;
  border-radius: 2px;
  background-color: #181a22;
  border: 1px solid #181a22;
  cursor: pointer;

  &:hover {
    border: 1px solid ${rgba(mainColors.customSlate, 0.4)};
    background: #222530;
  }

  ${({ hasNotifications }) =>
    hasNotifications &&
    css`
      &:after {
        content: ' ';
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        bottom: 60%;
        left: 60%;
        background-color: ${semanticColors.failureMedium};
      }
    `}
`
